<template>
    <div class="signin-form-container">
        <el-row type="flex" justify="center">
            <el-col :xs="{span:24}" :span="12" >

                <el-row type="flex" justify="center" :gutter="15">
                    <el-col :xs="24" >
                        <div class="input-label">ایمیل:</div>
                        <el-input placeholder="ایمیل" v-model="email">
                            <template slot="append">
                                <app-mail-icon/>
                            </template>
                        </el-input>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" :gutter="15">
                    <el-col :span="24" >
                        <div class="input-label">رمز عبور:</div>
                        <el-input placeholder="رمز عبور" v-model="password" show-password>
                            <template slot="append">
                                <app-key-icon/>
                            </template>
                        </el-input>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" :gutter="15">
                    <el-col :span="24" >
                        <el-button type="primary" @click="signIn">
                            ورود
                        </el-button>
                    </el-col>
                </el-row>

                <el-divider></el-divider>

                <el-row type="flex" justify="center" :gutter="15">
                    <el-col :span="24" class="link-col">
                        گذرواژه خود را فراموش کرده اید؟
                        <router-link to="/auth/reset-password" class="go-to-reset-password-link">
                            بازیابی گذرواژه »
                        </router-link>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'AppLogin',
        data() {
            return {
                email: '',
                password: ''
            }
        },
        methods: {
            signIn() {
                //mehdi@owjadmin1398 owjedu.ir@gmail.com
                this.$http.post(
                    `${this.apiURL}/user/signin`,
                    { email: this.email, password: this.password }
                ).then( (response) => {
                    localStorage.setItem('auth', JSON.stringify(
                        {
                            accessToken: response.data.accessToken,
                            refreshToken: response.data.refreshToken,
                            refreshTokenExp: response.data.refreshTokenExp,
                            user: response.data.user
                        }
                    ));
                    this.$router.push({name: 'dashboard-profile'});
                }).catch( (error) => {
                    console.error(error);
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .signin-form-container {

        .el-row {
            margin-bottom: 20px;

            .el-col {

                .input-label {
                    text-align: right;
                    direction: rtl;
                    font-size: 14px;
                }

                .el-input {
                    direction: ltr;

                    &::v-deep {
                        input {
                            direction: rtl;
                            background-color: #f8fafd;
                        }

                        .el-input-group__append {

                            svg {
                                vertical-align: text-top;
                            }
                        }
                    }
                }

                .el-button {
                    width: 100%;
                    margin: 20px 0 0 0;

                    svg {
                        vertical-align: text-top;
                    }
                }

                &.link-col {
                    font-size: 14px;
                    text-align: right;
                    direction: rtl;
                    color: #7E93A8;

                    .go-to-reset-password-link {
                        text-decoration: none;
                        transition: 0.4s all ease;
                        color: #3D97F2;

                        &:hover {
                            color: #007FFF;
                        }
                    }
                }

            }

            .el-divider {
                margin: 9px 0;
            }
        }
    }
</style>
